import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { getSkuCategoryDetailUrl, getCategoryProductUrl, getOrderSummaryUrl, comparePriceBtwPricingGeoUrl, getpricingGeographyUrl, createDPOrderUrl, deleteDPUrl, modifyOrderUrl } from "../urls";

export const createDispatchPlanAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${createDPOrderUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};


export const getSkuCategoryDetailAction = async (companyid, data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${getSkuCategoryDetailUrl()}?company_id=${companyid}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetCategoryProductsAction = async (company_esi_id, data, pricing_geography_id = null,) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const queryParams = new URLSearchParams();
    queryParams.append('company_esi_id', company_esi_id);
    if (pricing_geography_id) queryParams.append('manufacturer_pricing_geography_id', pricing_geography_id);
    const url = `${getCategoryProductUrl()}?${queryParams.toString()}`;
    await axios
      .post(url,
      data, 
      getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getpricingGeographyAction = async (params) => {
  return new Promise(async (next) => {
    await axios
      .get(getpricingGeographyUrl(), { params })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const comparePricesBtwPricingGeoAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
        `${comparePriceBtwPricingGeoUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getOrderCostAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .post(`${getOrderSummaryUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const DeleteOrderAction = async (payload) => {
  return new Promise(async (next) => {
    const params = new URLSearchParams(payload);
    let token = await getToken();
    await axios
      .delete(deleteDPUrl(), {
        params: params,
        ...getTokenHeader(token),
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const ModifyOrderAction = async (data, company_esi_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .post(
         `${modifyOrderUrl()}?user_esi_id=${company_esi_id}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

